import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import Masonry from "react-masonry-css";
import { Context } from "../../Context/ContextApi";

const Shop = () => {
  const { painting } = useContext(Context);
  const [product, setProduct] = useState([]);

  const { pathname } = useLocation();
  const url = pathname?.split("/")[2];

  useEffect(() => {
    axios
      .get(`https://admin.tulikaarts.in/api/products/${url}`)
      .then((response) => setProduct(response.data?.products || []))
      .catch((error) => console.log(error));
  }, [url]);

  // Masonry breakpoints
  const breakpointColumnsObj = {
    default: 4,
    1200: 3,
    900: 2,
    600: 1,
  };

  return (
    <div className="container shop-page py-5">
      <h1 className="text-center mb-4">Vibrant  Art by Tulika</h1>

      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {product?.map((painting) => (
          <div key={painting.id} className="masonry-item p-2">
            <div className="card border-0 shadow-sm rounded-3 overflow-hidden">
              <Link to={`/painting/${painting.product_url}`}>
                <img
                  src={`https://admin.tulikaarts.in/${painting?.product_image}`}
                  alt={painting.product_name}
                  className="img-fluid"
                />
              </Link>
              <div className="card-body">
                <h5 className="fw-bold mb-3">{painting.product_name}</h5>

                {/* Size and Price in one row */}
                <div className="d-flex justify-content-between align-items-center">
                  <p className="mb-0 text-muted">
                    <b>Size:</b> {painting.product_size}
                  </p>
                  <p className="mb-0 fw-bold text-black" style={{ color: '#cc9051' }}>
                    ₹ {painting.product_price}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Masonry>
    </div>
  );
};

export default Shop;
